import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { AlertEntity } from "../../types/AlertEntity";
import { AlertDtoToEntity } from "../mappers/AlertDtoToEntity";
import { AlertEntityToDto } from "../mappers/AlertEntityToDto";

const AlertApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        AlertLoad: builder.query<AlertEntity, FormQuery>({
            providesTags: [ResourceName.ALERTS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALERTS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return AlertDtoToEntity(response);
            },
        }),
        AlertSave: builder.mutation<AlertEntity, FormMutation<AlertEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALERTS}`;
                const method = "POST";

                const body = AlertEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.ALERTS],
        }),
        AlertUpdate: builder.mutation<AlertEntity, FormMutation<AlertEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ALERTS}/${mutation.data.id}`;
                const method = "PUT";

                const body = AlertEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.ALERTS],
        }),
    }),
});

export const { useAlertLoadQuery, useAlertSaveMutation, useAlertUpdateMutation } = AlertApi;
